var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepByStepVideos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Step-by-step_videos_",
    "data-name": "Step-by-step videos ",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3720"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 143",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    transform: "translate(0 0)",
    fill: "#ff808a"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3822",
    "data-name": "Group 3822",
    transform: "translate(11 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3821",
    "data-name": "Group 3821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M831.794,393.86l3.436,1.991-3.443,1.98-3.443,1.98.006-3.972.006-3.972Z",
    transform: "translate(-813.7 -379.822)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3820",
    "data-name": "Group 3820"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_394",
    "data-name": "Line 394",
    x2: 35.826,
    transform: "translate(0 5.966)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1208",
    "data-name": "Rectangle 1208",
    width: 36,
    height: 28.427,
    rx: 1.622,
    transform: "translate(0.177)",
    fill: "none",
    stroke: "#121e59",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_395",
    "data-name": "Line 395",
    x2: 9,
    transform: "translate(3.55 25.763)",
    fill: "none",
    stroke: "#121e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_396",
    "data-name": "Line 396",
    x2: 1.501,
    transform: "translate(15.299 25.763)",
    fill: "none",
    stroke: "#121e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepByStepVideos);
export default __webpack_public_path__ + "static/media/stepByStepVideos.b4780d4a2e05c72cc984b8d30c590145.svg";
export { ForwardRef as ReactComponent };